'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _webrtcAdapter = require('webrtc-adapter');
var _webrtcAdapter2 = _interopRequireDefault(_webrtcAdapter);
var _reactDom = require('react-dom');
var _providersMcu = require('./providers/Mcu');
var _providersMcu2 = _interopRequireDefault(_providersMcu);
var _containersVideoRoom = require('./containers/VideoRoom');
var _containersVideoRoom2 = _interopRequireDefault(_containersVideoRoom);
var _actionsVideoRoom = require('./actions/videoRoom');
var videoRoomActions = _interopRequireWildcard(_actionsVideoRoom);
var _reducersMcu = require('./reducers/mcu');
var _reducersMcu2 = _interopRequireDefault(_reducersMcu);
var _reducersVideoRoom = require('./reducers/videoRoom');
var _reducersVideoRoom2 = _interopRequireDefault(_reducersVideoRoom);
var _utilsJanus = require('./utils/janus');
var _utilsJanus2 = _interopRequireDefault(_utilsJanus);
if (window) {
  window.adapter = _webrtcAdapter2['default'];
}
exports['default'] = {
  Mcu: _providersMcu2['default'],
  VideoRoom: _containersVideoRoom2['default'],
  videoRoomActions: videoRoomActions,
  janusReducers: [_reducersMcu2['default'], _reducersVideoRoom2['default']],
  Janus: _utilsJanus2['default']
};
module.exports = exports['default'];